import { useTranslation } from '@govard/i18n-core/react';
import type { ReactElement } from 'react';
import { Card } from 'antd';

interface OperatorModulePageProps {
  titleKey:
    | 'crm.operator.module.prompt_compiler'
    | 'crm.operator.module.knowledge'
    | 'crm.operator.module.files'
    | 'crm.operator.module.agent_monitor'
    | 'crm.operator.module.opencode';
}

export default function OperatorModulePage({ titleKey }: OperatorModulePageProps): ReactElement {
  const { t } = useTranslation();
  return (
    <main
      className="animate-fade-in flex flex-col p-6 mx-auto w-full"
      style={{
        gap: 20,
        backgroundColor: 'var(--ant-color-bg-layout)',
        minHeight: '100vh',
        maxWidth: 1200,
      }}
    >
      <header className="mb-2">
        <h1
          className="font-bold tracking-tight"
          style={{ fontSize: 24, color: 'var(--ant-color-text)' }}
        >
          {t(titleKey)}
        </h1>
        <p style={{ fontSize: 13, color: 'var(--ant-color-text-tertiary)', marginTop: 4 }}>
          {t('crm.operator.restored')}
        </p>
      </header>

      <Card>
        <h2 className="font-semibold" style={{ fontSize: 16, color: 'var(--ant-color-text)' }}>
          {t('crm.operator.parity_title')}
        </h2>
        <p style={{ fontSize: 13, color: 'var(--ant-color-text-secondary)', marginTop: 4 }}>
          {t('crm.operator.parity_description')}
        </p>
        <div style={{ marginTop: 16, fontSize: 13, color: 'var(--ant-color-text-tertiary)' }}>
          {t('crm.operator.skeleton_only')}
        </div>
      </Card>
    </main>
  );
}
